import { PageContainer } from "@ant-design/pro-components";

import { TruckForm } from "components";

export const CreateTruckPage = () => (
  <PageContainer>
    <TruckForm />
  </PageContainer>
);
